import { render, staticRenderFns } from "./SlotClosureCalendar.vue?vue&type=template&id=38d3ec40&scoped=true"
import script from "./SlotClosureCalendar.vue?vue&type=script&lang=js"
export * from "./SlotClosureCalendar.vue?vue&type=script&lang=js"
import style0 from "./SlotClosureCalendar.vue?vue&type=style&index=0&id=38d3ec40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3ec40",
  null
  
)

export default component.exports